import * as React from "react";

interface ArrowDownIconProps {
  color?: string;
}

const ExpenseDown: React.FC<ArrowDownIconProps> = ({ color }) => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={32} height={32} rx={16} fill="#FEE4E2" />
      <g clipPath="url(#clip0_56726_68140)" stroke="#D92D20" strokeWidth={1.4}>
        <path
          d="M20.5 11.5c.975.097 1.631.315 2.121.808.879.884.879 2.307.879 5.154 0 2.846 0 4.27-.879 5.154-.878.884-2.293.884-5.121.884h-3c-2.828 0-4.243 0-5.121-.884-.879-.885-.879-2.308-.879-5.154 0-2.847 0-4.27.879-5.154.49-.493 1.146-.711 2.121-.808"
          strokeLinecap="round"
        />
        <path
          d="M20.883 17.5h-.007M11.133 17.5h-.007"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M17.875 17.5a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0z" />
        <path
          d="M14.125 10.375C14.494 9.995 15.475 8.5 16 8.5m1.875 1.875C17.506 9.995 16.525 8.5 16 8.5m0 0V13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_56726_68140">
          <path fill="#fff" transform="translate(7 7)" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ExpenseDown };
